import type { CollectionPlayer, CollectionSlide } from '@collection-player/types/collection-player.type'

export const generateNewCollection = (
  t: (key: string, values?: Record<string, string | number>) => string,
): CollectionPlayer => ({
  name: t('canvasUI.collectionSelector.defaultNewCollectionName'),
  groups: [],
  hide_footer: false,
})

export const generateNewCollectionStructure = (): CollectionPlayer => ({ name: '', groups: [] })

export const getUniqueSlides = (uniqueSlides: CollectionSlide[], newSlides: CollectionSlide[]) => [
  ...uniqueSlides,
  ...newSlides.filter(
    (newSlide) =>
      !uniqueSlides.some(
        (uniqueSlide) =>
          newSlide.type === 'slide' &&
          uniqueSlide.type === 'slide' &&
          uniqueSlide.file.id === newSlide.file.id &&
          uniqueSlide.slide.index === newSlide.slide.index,
      ),
  ),
]
